import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

const topicActions = getActionTypes('topic', [
    'GET_ALL',
    'GET',
    'CREATE',
    'UPDATE',
    'DELETE'
]);

const initialTopicState = {
    ...generateDefaultState('topic', [
        'GET_ALL',
        'GET',
        'CREATE',
        'UPDATE',
        'DELETE'
    ]),
    createdTopic: {}
}

const messageActions = getActionTypes('message', [
    'GET_ALL',
    'GET'
]);

export const actions = {
    ...topicActions,
    ...messageActions
}

const initialMessageState = {
    ...generateDefaultState('message', [
        'GET_ALL',
        'GET'
    ])
};

export const initialChatState = {
    ...initialTopicState,
    ...initialMessageState
}
